import React, {useState} from 'react'

import BSwitch from 'components/Form/Fields/BSwitch'

const HiddenField = ({Title, defaultState, children}) => {
  const [visible, setVisible] = useState(defaultState)

  return (
    <div className='hiddenField'>
      <div className='hiddenField-controls'>
        {Title} <BSwitch checked={visible} onChange={setVisible}/>
      </div>

      <div className={visible ? 'hiddenField-visible' : 'hiddenField-hidden'}>
        {children}
      </div>
    </div>
  )
}

export default HiddenField
